// ============================================
//  TOP MV
// ============================================
function mv() {
  const root = document.querySelector('.p-index-mv');
  if (!root) return;

  root.classList.add('is-active');

  const wrap = root.querySelector('.p-index-mv__imgWrap');
  const basePath = wrap.dataset.base;
  const tiles = [...root.querySelectorAll('.p-index-mv__img')];
  if (tiles.length < 4) return;

  // 固定させるやつ
  const fixedNums = ['02', '03', '11', '12'];

  // 可変タイルのindex取得
  const variableIndexes = tiles
    .map((tile, i) => {
      const img = tile.querySelector('img');
      const m = img.src.match(/img-mv(\d{2})/);
      return m && !fixedNums.includes(m[1]) ? i : null;
    })
    .filter((i) => i !== null);

  // 可変用の画像番号（必ず8個）
  const allNums = ['01', '04', '05', '06', '07', '08', '09', '10'];

  function shuffle(arr) {
    return [...arr].sort(() => Math.random() - 0.5);
  }

  // ✅ 同じ位置に同じ値が入らないシャッフル
  function shuffleDifferent(arr) {
    let shuffled;
    let isSame = true;

    while (isSame) {
      shuffled = shuffle(arr);
      isSame = shuffled.some((val, i) => val === arr[i]);
    }

    return shuffled;
  }

  // 現在の状態
  let currentNums = shuffle(allNums);

  // --------------------------
  // 初期反映
  // --------------------------
  function applyAll() {
    variableIndexes.forEach((tileIndex, i) => {
      const tile = tiles[tileIndex];
      const picture = tile.querySelector('picture');
      const source = picture.querySelector('source');
      const img = picture.querySelector('img');

      const num = currentNums[i];

      source.srcset = `${basePath}img-mv${num}.jpg`;
      img.src = `${basePath}img-mv${num}_S.jpg`;
    });
  }

  applyAll();

  // --------------------------
  // 列数取得
  // --------------------------
  function getCols() {
    return getComputedStyle(wrap).gridTemplateColumns.split(' ').length;
  }

  // --------------------------
  // 隣接しない4枚選出
  // --------------------------
  function pickFour() {
    const cols = getCols();
    const result = [];
    const maxTries = 100;
    let tries = 0;

    function isNear(a, b) {
      const ax = a % cols;
      const ay = Math.floor(a / cols);
      const bx = b % cols;
      const by = Math.floor(b / cols);
      return Math.abs(ax - bx) + Math.abs(ay - by) === 1;
    }

    while (result.length < 4 && tries < maxTries) {
      tries++;
      const r = variableIndexes[Math.floor(Math.random() * variableIndexes.length)];
      if (!result.some((i) => i === r || isNear(i, r))) {
        result.push(r);
      }
    }

    while (result.length < 4) {
      const r = variableIndexes[Math.floor(Math.random() * variableIndexes.length)];
      if (!result.includes(r)) result.push(r);
    }

    return result;
  }

  // --------------------------
  // 4枚だけ入れ替え（必ず変わる）
  // --------------------------
  function swapFour() {
    const indexes = pickFour();

    // variableIndexes内の位置に変換
    const numIndexes = indexes.map((index) => variableIndexes.indexOf(index));

    const values = numIndexes.map((i) => currentNums[i]);

    // ✅ 絶対に同じ位置に同じ画像が来ない
    const shuffled = shuffleDifferent(values);

    numIndexes.forEach((numIndex, i) => {
      currentNums[numIndex] = shuffled[i];
    });

    // DOM反映（アニメ付き）
    indexes.forEach((tileIndex, i) => {
      const tile = tiles[tileIndex];
      const picture = tile.querySelector('picture');
      const source = picture.querySelector('source');
      const img = picture.querySelector('img');

      const delay = i * 150;

      setTimeout(() => {
        tile.classList.add('is-tile-start');

        setTimeout(() => {
          const num = currentNums[variableIndexes.indexOf(tileIndex)];
          source.srcset = `${basePath}img-mv${num}.jpg`;
          img.src = `${basePath}img-mv${num}_S.jpg`;
        }, 900);

        setTimeout(() => {
          tile.classList.remove('is-tile-start');
        }, 800);
      }, delay);
    });
  }

  // --------------------------
  // ループ
  // --------------------------
  function run() {
    swapFour();
    setTimeout(run, 4000);
  }

  setTimeout(run, 2500);
}

export { mv };
